import { render, staticRenderFns } from "./EditGuardia.vue?vue&type=template&id=bcbde8b6&"
import script from "./EditGuardia.vue?vue&type=script&lang=js&"
export * from "./EditGuardia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports